<div class="flex flex-col justify-center items-center w-full">
  @if (risk() === 'personal_accidents') {
  <div class="w-full text-center mb-10">
    Todas las coberturas cubren la
    <strong>jornada laboral con su respectivo traslado</strong> (sin motocicleta).
  </div>
  }

  @if (risk() === 'quad') {
  <app-disclaimer class="mb-10"
    text="Para cuatriciclos y areneros la cobertura de garage es obligatoria. Sólo se cubrirán vehículos patentados y mientras circulen en vías habilitadas." />
  }

  <!-- Gated on id only: backend always sends a priced additionalCoverage for classic_car at this step. -->
  @if (risk() === 'classic_car' && additionalCoverage()?.id) {
  <app-quoter-sidebar-coverage [coverage]="additionalCoverage()!" [currency]="currency()" class="w-full mb-10" />
  }

  <div class="flex flex-col md:flex-row gap-5 w-full">
    @for (coverage of coverages(); track coverage.id) { @if
    (shouldDisplayCoverage(coverage)) {
    <app-quoter-coverage-card [coverage]="coverage" (coverageSelected)="setCoverage($event)" />
    } }
  </div>
</div>